import React, { useMemo, useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { useWebsite } from "../../../Context/WebSiteContext";

const NavbarModern = ({ config }) => {
  const { formData } = useWebsite();
  const [scrolled, setScrolled] = useState(false);

  // Detectar scroll
  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navColorRaw = formData?.navbar?.colornav || config?.navbar?.colornav;
  const navTextColorRaw =
    formData?.navbar?.colornavtext || config?.navbar?.colornavtext;

  let tempNavColor = typeof navColorRaw === "string" ? navColorRaw.trim() : "";
  if (!tempNavColor.startsWith("#")) tempNavColor = `#${tempNavColor}`;
  if (tempNavColor.length !== 7 && tempNavColor.length !== 4)
    tempNavColor = "#ffffff";
  const navColor = tempNavColor;

  let tempNavTextColor =
    typeof navTextColorRaw === "string" ? navTextColorRaw.trim() : "";
  if (!tempNavTextColor.startsWith("#"))
    tempNavTextColor = `#${tempNavTextColor}`;
  if (tempNavTextColor.length !== 7 && tempNavTextColor.length !== 4)
    tempNavTextColor = "#000000";
  const navTextColor = tempNavTextColor;

  const navLinks = Array.isArray(formData?.navbar?.nav_links)
    ? formData.navbar.nav_links.filter(Boolean)
    : [];

  const style = useMemo(
    () => ({
      background: scrolled ? navColor : "transparent",
      color: navTextColor,
      transition: "background 0.3s ease",
      position: "fixed",
      top: 0,
      width: "100%",
      zIndex: 1000,
    }),
    [navColor, navTextColor, scrolled]
  );

  const telSite = formData?.navbar?.Tel_Site || "";
  const whatsappNumber = telSite.replace(/\D/g, "");
  const whatsappLink = whatsappNumber
    ? `https://wa.me/55${whatsappNumber}`
    : "#";

  const labelMap = {
    Home: "Início",
    About: "Sobre",
    Gallery: "Galeria",
    Contact: "Contato",
  };

  return (
    <Navbar expand="lg" style={style} className="px-3">
      <Container fluid>
        <Navbar.Brand className="d-flex align-items-center">
          {formData.logo && (
            <img
              src={formData.logo}
              alt="Logo"
              style={{ height: 50, marginRight: 12, objectFit: "contain" }}
            />
          )}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-modern-content" />
        <Navbar.Collapse
          id="navbar-modern-content"
          className="justify-content-end"
        >
          <Nav className="d-flex align-items-center gap-3">
            {navLinks.map((label, idx) => (
              <Nav.Link
                key={idx}
                href={`#${label.toLowerCase()}`}
                style={{
                  color: navTextColor,
                  fontWeight: 500,
                  fontSize: 15,
                }}
              >
                {labelMap[label] || label}
              </Nav.Link>
            ))}
            {formData?.navbar?.link_instagram && (
              <Nav.Link
                href={`https://instagram.com/${formData.navbar.link_instagram.replace(
                  /^@/,
                  ""
                )}`}
                target="_blank"
                style={{ color: navTextColor }}
              >
                <i className="bi bi-instagram" style={{ fontSize: "1.4rem" }}></i>
              </Nav.Link>
            )}
            {telSite && (
              <Nav.Link
                href={whatsappLink}
                target="_blank"
                style={{ color: navTextColor }}
              >
                <i className="bi bi-whatsapp" style={{ fontSize: "1.4rem" }}></i>
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarModern;
